<!-- 饼图 -->
<style lang="stylus" scoped>
.pie2 {
  width: 100%;
  height: 284px;

  .main {
    width: 100%;
    height: 284px;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="pie2">
      <div class="main"></div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from '../common/boxWrap';
export default {
  props: ['distributedBar'],
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {},
      name: '历史数据迁移统计',
      dataX: [],
      timer2: null,
      chartData: []
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    var count = 0
    // for (var i = 0; i < this.distributedBar.length; i++) {
    //   if (this.distributedBar[i].regionName && count < 8) {
    //     this.dataX.push(this.distributedBar[i].regionName)
    //     this.chartData.push({ value: this.distributedBar[i].number, name: this.distributedBar[i].regionName })
    //     count++
    //   }

    //   // console.log(this.dataX, this.chartData)
    // }
    this.dataX = ['数据已迁移', '数据待迁移', '数据迁移中']
    this.chartData = [
      { name: '数据已迁移', value: 40 },
      { name: '数据待迁移', value: 30 },
      { name: '数据迁移中', value: 30 }
    ]
    // console.log(this.chartData)
    const data = this.chartData;
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.pie2 .main'));
    var op = {
      title: {
        show: false
      },
      legend: [{
        // orient: 'vertical',
        // left: '10',
        // top: '20',
        bottom: 20,
        data: this.dataX,
        textStyle: {
          color: "#00fefb",
          fontSize: 14
        }
      }],
      tooltip: {
        // trigger: 'item',
        formatter: "{b} : {d}% <br/> {c}"
      },
      color: this.color,
      series: [
        {
          name: '访问来源',
          type: 'pie',
          radius: ['30%', '60%'],
          center: ['50%', '40%'],
          data,
          label: {
            position: 'outside'
          },
          labelLine: {
            show: true
          },
          itemStyle: {
            position: 'outside',
            normal: {
              label: {
                show: true,
                fontSize: 16,
                position: 'outside',
                formatter: '{d}%',
                color: "#fff"
              },
              labelLine: {
                show: true
              }
            },
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    }
    this.myChart.setOption(op);
    this.init();
    // 切换具体的子地图
    let index = 0;
    clearInterval(this.timer2);
    this.timer2 = setInterval(() => {
      this.myChart.dispatchAction({
        type: "showTip",
        seriesIndex: 0,
        dataIndex: index
      });
      for (var i = 0; i < op.series[0].data.length; i++) {
        op.series[0].data[i]['selected'] = false;
      }
      op.series[0].data[index]['selected'] = true;
      this.myChart.setOption(op);
      index++;
      if (index >= 3) {
        index = 0;
      }
    }, 4000);
  },
  beforeDestroy() {
    clearInterval(this.timer2);
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?a8cfe3a2